import styled, { css } from 'styled-components';

import { crFont11, crFont9, crFont13 } from '@controlrooms/web/src/app/global-styles';

export const DropdownRootStyled = styled.div`
  position: relative;
  display: inline-block;
`;

export const DropdownTriggerStyled = styled.div`
  ${crFont13}
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: 10px;
  svg {
    path: ${({ theme }) => theme.dropdown.optionTextColor};
  }
`;

export const DropdownOptionsStyled = styled.div<{
  position?: 'left' | 'right' | 'center' | 'justified';
  vertical?: 'top' | 'bottom';
  open?: boolean;
  width?: string;
  clickAnchor?: { x: number; y: number };
}>`
  background: ${({ theme }) => theme.dropdown.optionBackgroundColor};
  position: ${({ clickAnchor }) => (clickAnchor ? 'fixed' : 'absolute')};
  display: none;
  min-width: 120px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  z-index: 1000;

  ${({ clickAnchor }) =>
    clickAnchor &&
    css`
      left: ${clickAnchor.x}px;
      top: ${clickAnchor.y}px;
    `}

  /* Positioning based on vertical + position combination (used when !clickAnchor):
   * top-left: dropdown's bottom-right at trigger's top-left (0,0)
   * top-right: dropdown's bottom-left at trigger's top-right (0, 100%)
   * top-center: dropdown centered horizontally above trigger
   * top-justified: dropdown full width of trigger, center of trigger aligned to center of options
   * bottom-left: dropdown's top-right at trigger's bottom-left (100%, 0)
   * bottom-right: dropdown's top-left at trigger's bottom-right (100%, 100%)
   * bottom-center: dropdown centered horizontally below trigger (default)
   * bottom-justified: dropdown full width of trigger, center of trigger aligned to center of options
   */
  ${({ vertical, position, clickAnchor }) => {
    if (clickAnchor) return css``;
    if (vertical === 'top' && position === 'left') {
      return css`
        bottom: 100%;
        right: 100%;
        margin-bottom: 4px;
        margin-right: 4px;
      `;
    }
    if (vertical === 'top' && position === 'right') {
      return css`
        bottom: 100%;
        left: 100%;
        margin-bottom: 4px;
        margin-left: 4px;
      `;
    }
    if (vertical === 'top' && position === 'center') {
      return css`
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        margin-bottom: 4px;
      `;
    }
    if (vertical === 'top' && position === 'justified') {
      return css`
        bottom: 100%;
        left: 0;
        right: 0;
        margin-bottom: 4px;
      `;
    }
    if (vertical === 'bottom' && position === 'left') {
      return css`
        top: 100%;
        right: 100%;
        margin-top: 4px;
        margin-right: 4px;
      `;
    }
    if (vertical === 'bottom' && position === 'right') {
      return css`
        top: 100%;
        left: 100%;
        margin-top: 4px;
        margin-left: 4px;
      `;
    }
    if (vertical === 'bottom' && position === 'center') {
      return css`
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 4px;
      `;
    }
    if (vertical === 'bottom' && position === 'justified') {
      return css`
        top: 100%;
        left: 0;
        right: 0;
        margin-top: 4px;
      `;
    }
    // bottom-center (default)
    return css`
      top: 100%;
      left: 50%;
      margin-top: 4px;
    `;
  }}

  ${({ open }) =>
    open &&
    css`
      display: block;
    `}
  ${({ width }) =>
    width &&
    css`
      width: ${width};
    `}
`;

export const DropdownTitleStyled = styled.div`
  color: ${({ theme }) => theme.dropdown.titleTextColor};
  ${crFont9}
  padding: 6px 9px;
  text-align: left;
  cursor: pointer;
`;

export const DropdownItemStyled = styled.div<{ disabled?: boolean; active?: boolean }>`
  color: ${({ theme }) => theme.dropdown.optionTextColor};
  ${crFont11}
  padding: 6px 9px;
  text-align: left;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  text-transform: none;
  .submenu {
    display: none;
  }
  &:hover {
    background: ${({ theme }) => theme.sidebar.folders.hover.backgroundGradient};
    ${(props) => {
      if (props.disabled) {
        return `
        background: none;
        `;
      }
    }}
    .submenu {
      display: block;
    }
  }
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    `}
  ${({ active }) =>
    active &&
    css`
      background: ${({ theme }) => theme.sidebar.folders.hover.backgroundGradient};
    `}
`;

export const DropdownSeparatorStyled = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.dropdown.dividerColor};
  margin: 4px 0;
`;
